export default {
  methods: {
    onCountryUpdated: function (id) {
      this.currentCountry = id
    },
    onPostalCodeUpdated: function (code) {
      this.currentPostalCode = code
    },
    validatePostalCode: function () {
      this.dummyCounter++
    }
  },
  computed: {
    postalCodeErrors: function () {
      const errors = []
      if (this.dummyCounter === 0 && !this.currentPostalCode) return errors
      if (!this.currentPostalCode) errors.push(this.$t('validation_postalCode'))
      if (!this.currentCountry) errors.push(this.$t('validation_postalCode_missingCountry'))
      if (!this.countries[this.currentCountry] || !this.countries[this.currentCountry](this.currentPostalCode)) errors.push(this.$t('validation_postalCode_invalid'))
      return errors
    }
  },
  data: function () {
    return {
      postalCodeValidationForm: '',
      currentCountry: '',
      currentPostalCode: '',
      dummyCounter: 0,
      countries: {
        GB: function (v) { return /^GIR[ ]?0AA|((AB|AL|B|BA|BB|BD|BH|BL|BN|BR|BS|BT|CA|CB|CF|CH|CM|CO|CR|CT|CV|CW|DA|DD|DE|DG|DH|DL|DN|DT|DY|E|EC|EH|EN|EX|FK|FY|G|GL|GY|GU|HA|HD|HG|HP|HR|HS|HU|HX|IG|IM|IP|IV|JE|KA|KT|KW|KY|L|LA|LD|LE|LL|LN|LS|LU|M|ME|MK|ML|N|NE|NG|NN|NP|NR|NW|OL|OX|PA|PE|PH|PL|PO|PR|RG|RH|RM|S|SA|SE|SG|SK|SL|SM|SN|SO|SP|SR|SS|ST|SW|SY|TA|TD|TF|TN|TQ|TR|TS|TW|UB|W|WA|WC|WD|WF|WN|WR|WS|WV|YO|ZE)(\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}))|BFPO[ ]?\d{1,4}$/.test(v)},
        JE: function (v) { return /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/.test(v)},
        GG: function (v) { return /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/.test(v)},
        IM: function (v) { return /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/.test(v)},
        US: function (v) { return /^\d{5}([ \\-]\d{4})?$/.test(v)},
        CA: function (v) { return /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d$/.test(v)},
        DE: function (v) { return /^\d{5}$/.test(v)},
        JP: function (v) { return /^\d{3}-\d{4}$/.test(v)},
        FR: function (v) { return /^\d{2}[ ]?\d{3}$/.test(v)},
        AU: function (v) { return /^\d{4}$/.test(v)},
        IT: function (v) { return /^\d{5}$/.test(v)},
        CH: function (v) { return /^\d{4}$/.test(v)},
        AT: function (v) { return /^\d{4}$/.test(v)},
        ES: function (v) { return /^\d{5}$/.test(v)},
        NL: function (v) { return /^\d{4}[ ]?[A-Z]{2}$/.test(v)},
        BE: function (v) { return /^\d{4}$/.test(v)},
        DK: function (v) { return /^\d{4}$/.test(v)},
        SE: function (v) { return /^\d{3}[ ]?\d{2}$/.test(v)},
        NO: function (v) { return /^\d{4}$/.test(v)},
        BR: function (v) { return /^\d{5}[\\-]?\d{3}$/.test(v)},
        PT: function (v) { return /^\d{4}([\\-]\d{3})?$/.test(v)},
        FI: function (v) { return /^\d{5}$/.test(v)},
        AX: function (v) { return /^22\d{3}$/.test(v)},
        KR: function (v) { return /^\d{3}[\\-]\d{3}$/.test(v)},
        CN: function (v) { return /^\d{6}$/.test(v)},
        TW: function (v) { return /^\d{3}(\d{2})?$/.test(v)},
        SG: function (v) { return /^\d{6}$/.test(v)},
        DZ: function (v) { return /^\d{5}$/.test(v)},
        AD: function (v) { return /^AD\d{3}$/.test(v)},
        AR: function (v) { return /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/.test(v)},
        AM: function (v) { return /^(37)?\d{4}$/.test(v)},
        AZ: function (v) { return /^\d{4}$/.test(v)},
        BH: function (v) { return /^((1[0-2]|[2-9])\d{2})?$/.test(v)},
        BD: function (v) { return /^\d{4}$/.test(v)},
        BB: function (v) { return /^(BB\d{5})?$/.test(v)},
        BY: function (v) { return /^\d{6}$/.test(v)},
        BM: function (v) { return /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/.test(v)},
        BA: function (v) { return /^\d{5}$/.test(v)},
        IO: function (v) { return /^BBND 1ZZ$/.test(v)},
        BN: function (v) { return /^[A-Z]{2}[ ]?\d{4}$/.test(v)},
        BG: function (v) { return /^\d{4}$/.test(v)},
        KH: function (v) { return /^\d{5}$/.test(v)},
        CV: function (v) { return /^\d{4}$/.test(v)},
        CL: function (v) { return /^\d{7}$/.test(v)},
        CR: function (v) { return /^\d{4$/.test(v)},
        HR: function (v) { return /^\d{5}$/.test(v)},
        CY: function (v) { return /^\d{4}$/.test(v)},
        CZ: function (v) { return /^\d{3}[ ]?\d{2}$/.test(v)},
        DO: function (v) { return /^\d{5}$/.test(v)},
        EC: function (v) { return /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/.test(v)},
        EG: function (v) { return /^\d{5}$/.test(v)},
        EE: function (v) { return /^\d{5}$/.test(v)},
        FO: function (v) { return /^\d{3}$/.test(v)},
        GE: function (v) { return /^\d{4}$/.test(v)},
        GR: function (v) { return /^\d{3}[ ]?\d{2}$/.test(v)},
        GL: function (v) { return /^39\d{2}$/.test(v)},
        GT: function (v) { return /^\d{5}$/.test(v)},
        HT: function (v) { return /^\d{4}$/.test(v)},
        HN: function (v) { return /^(?:\d{5})?$/.test(v)},
        HU: function (v) { return /^\d{4}$/.test(v)},
        IS: function (v) { return /^\d{3}$/.test(v)},
        IN: function (v) { return /^\d{6}$/.test(v)},
        ID: function (v) { return /^\d{5}$/.test(v)},
        IL: function (v) { return /^\d{5}$/.test(v)},
        JO: function (v) { return /^\d{5}$/.test(v)},
        KZ: function (v) { return /^\d{6}$/.test(v)},
        KE: function (v) { return /^\d{5}$/.test(v)},
        KW: function (v) { return /^\d{5}$/.test(v)},
        LA: function (v) { return /^\d{5}$/.test(v)},
        LV: function (v) { return /^\d{4}$/.test(v)},
        LB: function (v) { return /^(\d{4}([ ]?\d{4})?)?$/.test(v)},
        LI: function (v) { return /^(948[5-9])|(949[0-7])$/.test(v)},
        LT: function (v) { return /^\d{5}$/.test(v)},
        LU: function (v) { return /^\d{4}$/.test(v)},
        MK: function (v) { return /^\d{4}$/.test(v)},
        MY: function (v) { return /^\d{5}$/.test(v)},
        MV: function (v) { return /^\d{5}$/.test(v)},
        MT: function (v) { return /^[A-Z]{3}[ ]?\d{2$/.test(v)},
        MU: function (v) { return /^(\d{3}[A-Z]{2}\d{3})?$/.test(v)},
        MX: function (v) { return /^\d{5}$/.test(v)},
        MD: function (v) { return /^\d{4}$/.test(v)},
        MC: function (v) { return /^980\d{2}$/.test(v)},
        MA: function (v) { return /^\d{5}$/.test(v)},
        NP: function (v) { return /^\d{5}$/.test(v)},
        NZ: function (v) { return /^\d{4}$/.test(v)},
        NI: function (v) { return /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/.test(v)},
        NG: function (v) { return /^(\d{6})?$/.test(v)},
        OM: function (v) { return /^(PC )?\d{3}$/.test(v)},
        PK: function (v) { return /^\d{5}$/.test(v)},
        PY: function (v) { return /^\d{4}$/.test(v)},
        PH: function (v) { return /^\d{4}$/.test(v)},
        PL: function (v) { return /^\d{2}-\d{3}$/.test(v)},
        PR: function (v) { return /^00[679]\d{2}([ \\-]\d{4})?$/.test(v)},
        RO: function (v) { return /^\d{6}$/.test(v)},
        RU: function (v) { return /^\d{6}$/.test(v)},
        SM: function (v) { return /^4789\d$/.test(v)},
        SA: function (v) { return /^\d{5}$/.test(v)},
        SN: function (v) { return /^\d{5}$/.test(v)},
        SK: function (v) { return /^\d{3}[ ]?\d{2}$/.test(v)},
        SI: function (v) { return /^\d{4}$/.test(v)},
        ZA: function (v) { return /^\d{4}$/.test(v)},
        LK: function (v) { return /^\d{5}$/.test(v)},
        TJ: function (v) { return /^\d{6}$/.test(v)},
        TH: function (v) { return /^\d{5}$/.test(v)},
        TN: function (v) { return /^\d{4}$/.test(v)},
        TR: function (v) { return /^\d{5}$/.test(v)},
        TM: function (v) { return /^\d{6}$/.test(v)},
        UA: function (v) { return /^\d{5}$/.test(v)},
        UY: function (v) { return /^\d{5}$/.test(v)},
        UZ: function (v) { return /^\d{6}$/.test(v)},
        VA: function (v) { return /^00120$/.test(v)},
        VE: function (v) { return /^\d{4}$/.test(v)},
        ZM: function (v) { return /^\d{5}$/.test(v)},
        AS: function (v) { return /^96799$/.test(v)},
        CC: function (v) { return /^6799$/.test(v)},
        CK: function (v) { return /^\d{4}$/.test(v)},
        RS: function (v) { return /^\d{6}$/.test(v)},
        ME: function (v) { return /^8\d{4}$/.test(v)},
        CS: function (v) { return /^\d{5}$/.test(v)},
        YU: function (v) { return /^\d{5}$/.test(v)},
        CX: function (v) { return /^6798$/.test(v)},
        ET: function (v) { return /^\d{4}$/.test(v)},
        FK: function (v) { return /^FIQQ 1ZZ$/.test(v)},
        NF: function (v) { return /^2899$/.test(v)},
        FM: function (v) { return /^(9694[1-4])([ \\-]\d{4})?$/.test(v)},
        GF: function (v) { return /^9[78]3\d{2}$/.test(v)},
        GN: function (v) { return /^\d{3}$/.test(v)},
        GP: function (v) { return /^9[78][01]\d{2}$/.test(v)},
        GS: function (v) { return /^SIQQ 1ZZ$/.test(v)},
        GU: function (v) { return /^969[123]\d([ \\-]\d{4})?$/.test(v)},
        GW: function (v) { return /^\d{4}$/.test(v)},
        HM: function (v) { return /^\d{4}$/.test(v)},
        IQ: function (v) { return /^\d{5}$/.test(v)},
        KG: function (v) { return /^\d{6}$/.test(v)},
        LR: function (v) { return /^\d{4}$/.test(v)},
        LS: function (v) { return /^\d{3}$/.test(v)},
        MG: function (v) { return /^\d{3}$/.test(v)},
        MH: function (v) { return /^969[67]\d([ \\-]\d{4})?$/.test(v)},
        MN: function (v) { return /^\d{6}$/.test(v)},
        MP: function (v) { return /^9695[012]([ \\-]\d{4})?$/.test(v)},
        MQ: function (v) { return /^9[78]2\d{2}$/.test(v)},
        NC: function (v) { return /^988\d{2}$/.test(v)},
        NE: function (v) { return /^\d{4}$/.test(v)},
        VI: function (v) { return /^008(([0-4]\d)|(5[01]))([ \\-]\d{4})?$/.test(v)},
        PF: function (v) { return /^987\d{2}$/.test(v)},
        PG: function (v) { return /^\d{3}$/.test(v)},
        PM: function (v) { return /^9[78]5\d{2}$/.test(v)},
        PN: function (v) { return /^PCRN 1ZZ$/.test(v)},
        PW: function (v) { return /^96940$/.test(v)},
        RE: function (v) { return /^9[78]4\d{2}$/.test(v)},
        SH: function (v) { return /^(ASCN|STHL) 1ZZ$/.test(v)},
        SJ: function (v) { return /^\d{4}$/.test(v)},
        SO: function (v) { return /^\d{5}$/.test(v)},
        SZ: function (v) { return /^[HLMS]\d{3}$/.test(v)},
        TC: function (v) { return /^TKCA 1ZZ$/.test(v)},
        WF: function (v) { return /^986\d{2}$/.test(v)},
        XK: function (v) { return /^\d{5}$/.test(v)},
        YT: function (v) { return /^976\d{2}$$/.test(v)}
      }
    }
  }
}